module.exports = __webpack_public_path__ + "static/media/LapTop-Video.5386b6fc.png";